<template>
  <div>
    <Headersys />
    <div class="content">
      <div class="realy-content">
        <div style="width: fit-content; margin: auto" v-if="print == '2'">
          <table
            class="table"
            ref="table"
            cellspacing="0"
            style="border-collapse: collapse; margin-left: 5px; width: 650px"
          >
            <tr>
              <td style="width: 500px; padding: 5px; border: 0" colspan="2">
                <div
                  style="
                    text-align: center;
                    font-weight: bold;
                    padding-bottom: 10px;
                  "
                >
                  公积金个人基本信息
                </div>
              </td>
            </tr>
            <tr>
              <td
                style="
                  width: 150px;
                  vertical-align: top;
                  text-align: center;
                  padding: 5px;
                  font-weight: bold;
                  border: 1px solid #000;
                "
              >
                职工账号
              </td>
              <td style="width: 500px; padding: 5px; border: 1px solid #000">
                {{ gjjInfo.grzh }}
              </td>
            </tr>
            <tr>
              <td
                style="
                  width: 150px;
                  vertical-align: top;
                  text-align: center;
                  padding: 5px;
                  font-weight: bold;
                  border: 1px solid #000;
                "
              >
                职工姓名
              </td>
              <td style="width: 500px; padding: 5px; border: 1px solid #000">
                {{ gjjInfo.xingming }}
              </td>
            </tr>
            <tr>
              <td
                style="
                  width: 150px;
                  vertical-align: top;
                  text-align: center;
                  padding: 5px;
                  font-weight: bold;
                  border: 1px solid #000;
                "
              >
                身份证号码
              </td>
              <td style="width: 500px; padding: 5px; border: 1px solid #000">
                {{ gjjInfo.zjhm }}
              </td>
            </tr>
            <tr>
              <td
                style="
                  width: 150px;
                  vertical-align: top;
                  text-align: center;
                  padding: 5px;
                  font-weight: bold;
                  border: 1px solid #000;
                "
              >
                开户日期
              </td>
              <td style="width: 500px; padding: 5px; border: 1px solid #000">
                {{ sliceTime(gjjInfo.khrq) }}
              </td>
            </tr>
            <tr>
              <td
                style="
                  width: 150px;
                  vertical-align: top;
                  text-align: center;
                  padding: 5px;
                  font-weight: bold;
                  border: 1px solid #000;
                "
              >
                单位账号
              </td>
              <td style="width: 500px; padding: 5px; border: 1px solid #000">
                {{ gjjInfo.dwzh }}
              </td>
            </tr>
            <tr>
              <td
                style="
                  width: 150px;
                  vertical-align: top;
                  text-align: center;
                  padding: 5px;
                  font-weight: bold;
                  border: 1px solid #000;
                "
              >
                单位名称
              </td>
              <td style="width: 500px; padding: 5px; border: 1px solid #000">
                {{ gjjInfo.dwmc }}
              </td>
            </tr>
            <tr>
              <td
                style="
                  width: 150px;
                  vertical-align: top;
                  text-align: center;
                  padding: 5px;
                  font-weight: bold;
                  border: 1px solid #000;
                "
              >
                个人缴存比例
              </td>
              <td style="width: 500px; padding: 5px; border: 1px solid #000">
                {{ numberToPercentage(gjjInfo.grjcl) }}
              </td>
            </tr>
            <tr>
              <td
                style="
                  width: 150px;
                  vertical-align: top;
                  text-align: center;
                  padding: 5px;
                  font-weight: bold;
                  border: 1px solid #000;
                "
              >
                单位缴存比例
              </td>
              <td style="width: 500px; padding: 5px; border: 1px solid #000">
                {{ numberToPercentage(gjjInfo.dwjcl) }}
              </td>
            </tr>
            <tr>
              <td
                style="
                  width: 150px;
                  vertical-align: top;
                  text-align: center;
                  padding: 5px;
                  font-weight: bold;
                  border: 1px solid #000;
                "
              >
                缴存基数
              </td>
              <td style="width: 500px; padding: 5px; border: 1px solid #000">
                {{ gjjInfo.grjcjs }}
              </td>
            </tr>
            <tr>
              <td
                style="
                  width: 150px;
                  vertical-align: top;
                  text-align: center;
                  padding: 5px;
                  font-weight: bold;
                  border: 1px solid #000;
                "
              >
                个人月缴存额
              </td>
              <td style="width: 500px; padding: 5px; border: 1px solid #000">
                {{ gjjInfo.gryjce }}
              </td>
            </tr>
            <tr>
              <td
                style="
                  width: 150px;
                  vertical-align: top;
                  text-align: center;
                  padding: 5px;
                  font-weight: bold;
                  border: 1px solid #000;
                "
              >
                单位月缴存额
              </td>
              <td style="width: 500px; padding: 5px; border: 1px solid #000">
                {{ gjjInfo.dwyjce }}
              </td>
            </tr>
            <!-- <tr>
            <td
              style="width: 150px;vertical-align: top;text-align: center;padding: 5px;font-weight: bold;border: 1px solid #000;">
              月缴存额</td>
            <td style="width: 500px;padding: 5px;border: 1px solid #000;">
              {{ gjjInfo.gryjce + gjjInfo.dwyjce }}
            </td>
          </tr> -->
            <tr>
              <td
                style="
                  width: 150px;
                  vertical-align: top;
                  text-align: center;
                  padding: 5px;
                  font-weight: bold;
                  border: 1px solid #000;
                "
              >
                缴至年月
              </td>
              <td style="width: 500px; padding: 5px; border: 1px solid #000">
                {{ gjjInfo.jzny }}
              </td>
            </tr>
            <tr>
              <td
                style="
                  width: 150px;
                  vertical-align: top;
                  text-align: center;
                  padding: 5px;
                  font-weight: bold;
                  border: 1px solid #000;
                "
              >
                账户状态
              </td>
              <td style="width: 500px; padding: 5px; border: 1px solid #000">
                {{ gjjInfo.grzhzt }}
              </td>
            </tr>
            <tr>
              <td style="width: 500px; padding: 5px; border: 0" colspan="2">
                <div style="float: right; width: 200px">
                  <div style="padding: 10px 0">奎文区自助服务终端</div>
                  <div>打印日期：{{ today }}</div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="load-mask" id="loadDom" v-if="maskShow"></div>
    </div>
    <Back :print="print" @toPrintEve="printPdfFile" />
    <div class="lt-mask" v-if="failShow" @click="failShow = false">
      <div class="ly-body" @click.stop="">
        <div class="lt-item">未查询到该证照(证明)信息</div>
        <div class="cl-btn" @click="goBackFail">返回</div>
      </div>
    </div>
  </div>
</template>
<script>
import lodop from "@/assets/js/doPrint.js";
import { Loading } from "element-ui";
export default {
  name: "",
  data() {
    return {
      gjjInfo: {},
      loadingInstance: null,
      waitTime: 180,
      watiTimer: null,
      print: "1", //打印按钮
      inquireNum: 0, //请求次数
      failShow: false, //未查询到证照提示
      maskShow: false,
      fmac: "",
      phone: "",
      name: "",
      idCard: "",
      today: "",
    };
  },
  created() {
    this.today = this.$fun.getTime(new Date());
  },
  mounted() {
    // return
    this.timeDown();
    this.maskShow = true;
    var localList =
      JSON.parse(localStorage.getItem(this.$store.state.suerInfo.cerno)) || [];
    var have = false;
    localList.forEach((el) => {
      if (el.class == "gjjinfo") {
        have = true;
        this.gjjInfo = el.list[0];
        this.print = "2";
        this.maskShow = false;
      }
    });
    if (!have) {
      setTimeout(() => {
        this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "正在查询...",
          target: document.querySelector("#loadDom"),
        });
      }, 1);
      // 公积金
      this.getGJJinfo();
    }
    this.$fun.getMAC((mac) => {
      this.fmac = mac;
      // var userInfo = JSON.parse(localStorage.getItem('USERINFO'))
    });
    var userInfo = this.$store.state.suerInfo;
    this.name = userInfo.name;
    this.phone = userInfo.tel;
    this.idCard = userInfo.cerno;
  },
  destroyed() {
    localStorage.removeItem("asdfgh");
    clearTimeout(this.watiTimer);
  },
  methods: {
    goBackFail() {
      this.failShow = false;
      this.$router.back();
    },
    // 倒计时
    timeDown() {
      this.watiTimer = setInterval(() => {
        if (this.waitTime > 1) {
          this.waitTime--;
        } else {
          this.waitTime = 180;
          clearInterval(this.watiTimer);
          this.$router.replace("/");
        }
      }, 1000);
    },
    printPdfFile(item) {
      this.$rqt.print_save({
        // type: "公积金个人基本信息",
        type: this.$route.query.title,
        fmac: this.fmac,
        name: this.name,
        phone: this.phone,
        idCard: this.idCard,
      });
      this.maskShow = true;
      setTimeout(() => {
        this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "正在打印...",
          target: document.querySelector("#loadDom"),
        });
      }, 500);
      const domElement = this.$refs.table;
      var dom = domElement.outerHTML;
      var html =
        '<!DOCTYPE html> <html lang = "en" > <head> <meta charset="UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0"><title>Document</title></head><body>' +
        dom +
        "</body></html>";
      // console.log(html);
      // 将字符串转换为Blob对象
      const blob = new Blob([html], { type: "text/plain;charset=utf-8" });

      // 创建File对象
      const fileObject = new File([blob], "filename.html", {
        type: "html/plain",
      });
      // console.log(fileObject);
      let params = new FormData();
      params.append("file", fileObject);
      this.$rqt.print_genHtml(params).then((res) => {
        // console.log(res);
        // domain
        // filePath
        var data = res.data;
        var url = data.domain + data.filePath.substring(1);
        var urls = url.replace("http://172.16.2.11", "http://123.131.74.138");
        console.log(urls);
        lodop.tablePrint(urls);
      });
      setTimeout(() => {
        this.loadingInstance.close();
      }, 16000);
    },
    // 公积金个人信息
    getGJJinfo() {
      this.$rqt
        .getDataInfo(localStorage.getItem("KWYSTOKEN"))
        .then((res) => {
          if (res.code == 200) {
            this.gjjInfo = res.rsdata[0];
            this.inquireNum = 0;
            this.loadingInstance.close();
            this.print = "2";
            this.maskShow = false;
            var cerno = this.$store.state.suerInfo.cerno;
            var localList = JSON.parse(localStorage.getItem(cerno)) || [];
            var local = {
              class: "gjjinfo",
              list: res.rsdata,
            };
            localList.push(local);
            localStorage.setItem(cerno, JSON.stringify(localList));
          } else {
            if (this.inquireNum < 5) {
              this.inquireNum++;
              this.getGJJinfo();
            } else {
              this.inquireNum = 0;
              this.loadingInstance.close();
              this.failShow = true;
            }
          }
        })
        .catch(() => {
          if (this.loadingInstance) {
            this.loadingInstance.close();
          }
          this.failShow = true;
        });
    },
    numberToPercentage(str) {
      var num = Number(str);
      return (num * 100).toFixed(2) + "%";
    },
    sliceTime(str) {
      if (!str) {
        return;
      }
      // return str.slice(0, 4) + '年' + str.slice(4, 6) + '月' + str.slice(6, 8) + '日'
      return str.slice(0, 10);
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  width: 70%;
  height: calc(100vh - 42rem - 40px);
  /* min-height: calc(100vh - 40px); */
  padding: 20px;
  margin: auto;
  background-color: #fff;
  /* overflow: scroll; */
  /* display: flex; */
  position: relative;
}

/* .content::-webkit-scrollbar {
  display: none;
} */

.realy-content {
  width: 100%;
  height: calc(100vh - 42rem - 40px);
  overflow: scroll;
}

.realy-content::-webkit-scrollbar {
  display: none;
  /* 对于Chrome, Safari和Opera */
}

.load-mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.qrCode-box {
  margin: auto;
  text-align: center;
}

.idCard-img {
  width: 180rem;
  margin-bottom: 2rem;
}

.print-btn {
  width: 34rem;
  height: 17rem;
  line-height: 17rem;
  background-color: rgb(34, 167, 244);
  color: #ffffff;
  text-align: center;
  border-radius: 10px;
  font-size: 7rem;
  cursor: pointer;
  margin: auto;
}

.print-btn:active {
  background-color: rgba(34, 167, 244, 0.5);
}

.lt-mask {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  background-color: rgba(0, 0, 0, 0.6);

  .ly-body {
    background-color: #fff;
    margin: auto;
    padding: 12rem;
    border-radius: 3rem;
    text-align: center;

    .lt-item {
      font-size: 8rem;
      margin-bottom: 2rem;

      .ipt {
        font-size: 8rem;
      }
    }

    .cl-btn {
      width: fit-content;
      margin: 6rem auto 0;
      padding: 3rem 6rem;
      background-color: #295eb5;
      font-size: 7rem;
      color: #ffffff;
      border-radius: 3rem;
    }

    .submit-btn {
      background-color: #24b34c;
    }

    .wxcode-img {
      display: block;
      margin: auto;
      width: 70rem;
      height: 70rem;
    }
  }
}

.load-mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
